import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';
import TableBody from 'modules/_shared/Table/components/TableBody';

import DividendsOperationTableRow from './DividendsOperationTableRow';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';

const DividendsOperationTableBody: FC = () => {
  const { t } = useTranslate();
  const { data } = useOperationDetailsPage();

  const { partners } = data;

  const hasData = partners?.length > 0;

  const rows = partners!.map((partner, index) => (
    <DividendsOperationTableRow
      // eslint-disable-next-line react/no-array-index-key
      key={`dividend-row-${index}`}
      index={index}
      partner={partner}
    />
  ));

  return (
    <TableBody
      hasData={hasData}
      content={rows}
      noDataMessage={t('NoDataFound')}
    />
  );
};

export default DividendsOperationTableBody;
